import { Box, Dialog, Link } from "@mui/material";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { validateFields } from "../../common/helper";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { Apikey } from "../../openApi/api";
import { ShowProgress } from "../../state/ShowProgress";
import * as yup from "yup";
import { toast } from "react-toastify";
import { apiKeyApi } from "../../openApi";
import { HTTP_RESPONSE_CODE } from "../../common/const";
import { ThemeLight } from "../../state/ThemeLight";

type Props = {
  open: boolean;
  handleOpen: (open: boolean) => void;
  apiKey?: Apikey;
  handleRefresh: () => void;
};

export const UpdateAPIKeyModal = ({
  open,
  handleOpen,
  apiKey,
  handleRefresh,
}: Props) => {
  const { userID, sessionKey, handleSessionKey } = useDeveloperContext();

  const [, setShowProgress] = useRecoilState(ShowProgress);
  const [themeLight] = useRecoilState(ThemeLight);

  const [name, setName] = useState<string>(apiKey?.appName ?? "");

  useEffect(() => {
    if (!open || !apiKey) {
      setName("");
      return;
    }

    setName(apiKey.appName);
  }, [open, apiKey]);

  const handleUpdate = async () => {
    try {
      await validateFields(
        yup.object().shape({
          name: yup.string().required("Please input the app name."),
        }),
        ["name"],
        [name]
      );
    } catch (err: any) {
      toast.warn(err.message, { theme: themeLight ? "light" : "dark" });
      return;
    }

    setShowProgress(true);

    apiKeyApi
      .updateKey(userID.toString(), {
        id: apiKey?.id ?? 0,
        accessToken: sessionKey!,
        appName: name,
      })
      .then((res) => {
        setShowProgress(false);
        toast.success("API key has been updated successfully.", {
          theme: themeLight ? "light" : "dark",
        });

        handleRefresh();
        handleOpen(false);
      })
      .catch((err) => {
        setShowProgress(false);
        if (err.response) {
          if (
            err.response.data.statusCode === HTTP_RESPONSE_CODE.UNAUTHORIZED
          ) {
            toast.error("Session key is expired", {
              theme: themeLight ? "light" : "dark",
            });
            handleSessionKey("");
          } else {
            toast.error(err.response.data.message, {
              theme: themeLight ? "light" : "dark",
            });
          }
        } else {
          toast.error(err.message, { theme: themeLight ? "light" : "dark" });
        }
      });
  };

  return (
    <Dialog open={open} onClose={() => handleOpen(false)} fullWidth>
      <Box
        className="modal modal-content"
        sx={{ borderRadius: "5px !important" }}
      >
        <Box className="modal-header">
          <h5 className="modal-title" id="myModalLabel">
            &nbsp;Create API Key
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => handleOpen(false)}
          ></button>
        </Box>
        <Box className="modal-body">
          <Box className="mb-4">
            <Box className="form-group " id="BoxApiKey">
              <label className="form-label">Api Key</label>
              <Box>
                <input
                  name="ctl00$ContentPlaceHolder1$txtApiKey"
                  type="text"
                  id="ContentPlaceHolder1_txtApiKey"
                  className="form-control py-2"
                  disabled
                  value={apiKey?.apiKey ?? ""}
                />
              </Box>
            </Box>
          </Box>
          <Box className="mb-4">
            <Box className="form-group">
              <label className="form-label">App Name</label>
              <Box>
                <input
                  name="ctl00$ContentPlaceHolder1$txtAppName"
                  type="text"
                  id="ContentPlaceHolder1_txtAppName"
                  className="form-control py-2"
                  placeholder="App Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <p></p>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="modal-footer bg-light">
          <Link
            data-bs-dismiss="modal"
            className="btn btn-ghost-white"
            onClick={() => handleOpen(false)}
          >
            Cancel
          </Link>
          <input
            type="submit"
            name="ctl00$ContentPlaceHolder1$btnSubmit"
            value="Save changes"
            id="ContentPlaceHolder1_btnSubmit"
            className="btn btn-primary"
            style={{ display: "block" }}
            onClick={handleUpdate}
          />
        </Box>
      </Box>
    </Dialog>
  );
};
